exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdr-custom-dates-combobox .v-chip--disabled{opacity:1;color:rgba(0,0,0,.87)!important}", ""]);

// exports
